// Bandeau promo sticky (sections/top-banner.liquid) — "jamais de 2e ligne,
// toujours un defilement automatique si le texte depasse la largeur du
// bandeau" (2026-09-10). Le markup contient 2 copies identiques du texte
// dans .top-banner__track (white-space:nowrap) ; ce script se contente de
// mesurer si UNE copie deborde de la zone visible et de basculer la classe
// .is-scrolling en consequence (l'animation CSS translateX(-50%) sur les
// 2 copies identiques boucle sans a-coup, voir assets/base.css).
(function () {
  var PX_PER_SECOND = 60; // vitesse de defilement constante, quelle que soit la longueur du texte

  function setup(banner) {
    var link = banner.querySelector('[data-top-banner-link]');
    var track = banner.querySelector('[data-top-banner-track]');
    if (!link || !track) return;
    var texts = track.querySelectorAll('.top-banner__text');
    var firstText = texts[0];
    if (!firstText) return;

    function check() {
      // Retire is-scrolling AVANT de mesurer : sinon la 2e copie (visible
      // uniquement quand is-scrolling est deja pose) fausserait la largeur
      // de reference (on ne veut mesurer qu'UNE seule copie du texte).
      track.classList.remove('is-scrolling');
      link.classList.remove('is-scrolling');
      var textWidth = firstText.getBoundingClientRect().width;
      var containerWidth = link.clientWidth;
      if (textWidth > containerWidth) {
        track.style.setProperty('--top-banner-scroll-duration', (textWidth / PX_PER_SECOND) + 's');
        track.classList.add('is-scrolling');
        // .top-banner__link garde justify-content:center par defaut (texte
        // court) ; en scroll, le texte doit partir de la gauche (sinon le
        // centrage coupe le debut du texte a la 1re frame). Voir aussi
        // assets/base.css.
        link.classList.add('is-scrolling');
      } else {
        track.style.removeProperty('--top-banner-scroll-duration');
      }
    }

    check();

    // 2026-09-10 : meme limite que le fix header.js du jour — resize
    // fenetre ne suffit pas, l'editeur de theme re-rend cette section en
    // AJAX des qu'on modifie le texte/la taille de police en direct.
    // ResizeObserver reagit a tout changement de taille reel (fenetre,
    // police qui charge, contenu qui change).
    if (window.ResizeObserver) {
      new ResizeObserver(check).observe(link);
    } else {
      window.addEventListener('resize', check);
    }
  }

  document.querySelectorAll('[data-top-banner]').forEach(setup);

  // Re-rendu de la section (curseur/champ modifie en direct dans
  // l'editeur de theme) = nouveau noeud DOM, jamais initialise ci-dessus.
  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target || !event.target.querySelectorAll) return;
    event.target.querySelectorAll('[data-top-banner]').forEach(setup);
  });
})();
